// src/utils/perm.js
export const hasRead = (userPerms = [], moduleKey) =>
  hasPerm(userPerms, moduleKey, "read");

export const hasWrite = (userPerms = [], moduleKey) =>
  hasPerm(userPerms, moduleKey, "write");

export const hasPerm = (userPerms = [], moduleKey, action = "read") => {
  if (!Array.isArray(userPerms)) return false;
  if (userPerms.includes("*")) return true;              // global wildcard
  if (userPerms.includes(`${moduleKey}:*`)) return true; // module wildcard
  return userPerms.includes(`${moduleKey}:${action}`);
};

// opts: { isAdmin?: boolean }
export const canSeeRoute = (userPerms = [], route, opts = {}) => {
  const { isAdmin = false } = opts || {};
  if (isAdmin) return true;                               // admin override
  if (!route?.meta?.perm) return true;                    // public route
  const action = route.meta.action || "read";
  return hasPerm(userPerms, route.meta.perm, action);
};
